import React from 'react';
import { Stack } from '@mui/material';
import { Help } from '@mui/icons-material';
import { palette, Text } from '@innovyze/stylovyze';
import { DarkInfoTooltip } from '@Components/deteriorationModel/configurationTab/DarkInfoTooltip';

export const renderDarkTooltipHeader = (label: string, heading: string, body: string): JSX.Element => (
	<Stack direction="row" spacing={0.5} alignItems="center" sx={{ overflow: 'hidden', cursor: 'default' }}>
		<Text style={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
			{label}
		</Text>
		<DarkInfoTooltip heading={heading} body={body}>
			<Help sx={{ fontSize: 'small', color: palette.secondary.main, flexShrink: 0 }} />
		</DarkInfoTooltip>
	</Stack>
);
